import React from "react";
import { RankingEntregaViewProps } from "../types";
import { NavigationButtons } from "./NavigationButtons";
import { LojaSelector } from "./LojaSelector";
import { ChamadoModal } from "./ChamadoModal";
import { Header } from "./Header";
import { Top3Entregadores } from "./Top3Entregadores";
import { FilaAguardando } from "./FilaAguardando";
import { FilaEmEntrega } from "./FilaEmEntrega";

export const RankingEntregaView: React.FC<RankingEntregaViewProps> = ({
  aguardando = [],
  emEntrega = [],
  top3Entregadores = [],
  lojas = [],
  selectedLojaId,
  showLojaSelector = false,
  showLojaSelectorUI = false,
  dateLabel,
  selectedLojaNome,
  chamadoAtual = null,
  segundosRestantes = 15,
  onGoHome,
  onToggleLojaSelector,
  onSelectAllLojas,
  onSelectLoja,
}) => {
  return (
    <div className="relative min-h-screen overflow-auto bg-gradient-to-br from-primary via-red-900 to-primary text-white">
      <NavigationButtons
        lojasCount={lojas.length}
        onGoHome={onGoHome}
        onToggleLojaSelector={onToggleLojaSelector}
        showLojaButton={showLojaSelectorUI}
      />

      {showLojaSelectorUI && (
        <LojaSelector
          lojas={lojas}
          selectedLojaId={selectedLojaId}
          showLojaSelector={showLojaSelector}
          onSelectAllLojas={onSelectAllLojas}
          onSelectLoja={onSelectLoja}
        />
      )}

      {chamadoAtual && (
        <ChamadoModal
          chamadoAtual={chamadoAtual}
          segundosRestantes={segundosRestantes}
        />
      )}

      <Header
        dateLabel={dateLabel}
        selectedLojaId={selectedLojaId}
        selectedLojaNome={selectedLojaNome}
      />

      <Top3Entregadores top3Entregadores={top3Entregadores} />

      <div className="flex-1 px-4 pb-6 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-2 lg:gap-8">
            <FilaAguardando aguardando={aguardando} />
            <FilaEmEntrega emEntrega={emEntrega} />
          </div>
        </div>
      </div>
    </div>
  );
};
